/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class ValueListApi extends BaseApi {
  endPoint: string = '/api/admin/value-list';
}
